function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 14.5c0-2.76 2.24-5 5-5h40c2.76 0 5 2.24 5 5v5c0 1.87-1.02 3.49-2.54 4.36.02.21.04.43.04.64v25c0 2.76-2.24 5-5 5h-35c-2.76 0-5-2.24-5-5v-25c0-.22.01-.44.04-.64A5.02 5.02 0 017 19.5v-5zm45 5v-5H12v5h40zm-37.5 5v25h35v-25h-35zM22 32a2.5 2.5 0 012.5-2.5h15a2.5 2.5 0 010 5h-15A2.5 2.5 0 0122 32z",
  fill: "#34214c"
})));